
export const useRouteParams = (path: string, currentPath: string) => {
  const routes = path.split("/");
  const currentRoutes = currentPath.split("/");
  return routes.map((itm: string, index: number) => {
    if(itm.includes(":")) return currentRoutes[index]
  }).filter(itm => itm !== undefined)
}